/* ============================================================
   GLOBAL MARKET AND FASHION — gmf-hero.js
   Efectos de entrada del hero. Idempotente.
   ============================================================ */
(function () {
  "use strict";
  if (window.__GMF_HERO_LOADED__) return;
  window.__GMF_HERO_LOADED__ = true;

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initHero() {
    var hero = document.querySelector(".gmf-hero");
    if (!hero) return;

    // Secuencia de entrada escalonada al cargar
    if (!reduceMotion) {
      var seq = hero.querySelectorAll("[data-gmf-hero-seq]");
      seq.forEach(function (el, i) {
        el.style.opacity = "0";
        el.style.transform = "translateY(16px)";
        el.style.animation = "gmf-fadeup 0.7s var(--gmf-ease) forwards";
        el.style.animationDelay = (0.1 + i * 0.09) + "s";
      });
    }

    // Parallax sutil de la imagen del hero según el mouse (solo escritorio)
    var stage = hero.querySelector(".gmf-hero__stage");
    var img = hero.querySelector(".gmf-hero__img");
    if (stage && img && !reduceMotion && window.matchMedia("(pointer:fine)").matches) {
      stage.addEventListener("mousemove", function (e) {
        var r = stage.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        img.style.transform = "translate3d(" + (x * 14).toFixed(1) + "px," + (y * 14).toFixed(1) + "px,0)";
      });
      stage.addEventListener("mouseleave", function () { img.style.transform = ""; });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initHero, { once: true });
  } else { initHero(); }

  document.addEventListener("shopify:section:load", initHero);
})();
